"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListener = void 0;

var _react = require("react");

const useListener = (eventType, element, listener) => (0, _react.useEffect)(() => {
  let subscription;

  if (element && listener) {
    subscription = element.on(eventType, listener);
  }

  return () => {
    var _subscription;

    return (_subscription = subscription) === null || _subscription === void 0 ? void 0 : _subscription.unsubscribe();
  }; // we shouldn't run this effect when eventType changes
  // which would turn out to be a different listener
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [element, listener]);

exports.useListener = useListener;